<script setup lang="ts">
    import { onMounted } from 'vue';
    import List from '@shared/components/List/List.vue';
    import CloneSmsListItem from './CloneSmsListItem.vue';
    import { useTextMessageList } from '../SmsList.service';
    import { type Status } from '../TextMessagesTypes';

    defineProps<{
        isBusy: boolean;
    }>();

    const emit = defineEmits<{
        clickedTextMessageId: [id: string];
        createNewTextMessage: [];
    }>();

    const { state, switchTab, filterOptions, orderOptions, filteredItems, initialize } = useTextMessageList();

    onMounted(async () => {
        await initialize();
    });

    const handleClickedTextMessageId = (textMessageId: string) => {
        emit('clickedTextMessageId', textMessageId);
    };

    const handleCreateNewTextMessage = () => {
        emit('createNewTextMessage');
    };
</script>

<template>
    <List
        v-if="state.tabData"
        itemId="SmsMessageId"
        :title="undefined"
        :description="state.tabData.description"
        :items="filteredItems()"
        :tabs="state.tabs"
        :currentTab="state.currentTab"
        :loading="state.isBusy"
        :filterKeys="filterOptions()"
        :orderOptions="orderOptions()"
        @update:tab="(newVal) => switchTab(newVal as Status)">
        <template #toolbar>
            <button v-if="state.hasScope" @click="handleCreateNewTextMessage" class="btn btn-default" v-show="state.selected.length === 0" :disabled="isBusy">
                <i class="glyphicon glyphicon-plus m-xxs-r"></i>
                {{ $Resources.SmsNewDraftButton }}
            </button>
        </template>
        <template #item="{ item, index }">
            <CloneSmsListItem :textMessage="item" :currentTab="state.currentTab" @clickedTextMessageId="handleClickedTextMessageId" />
        </template>
    </List>
</template>
